"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var lodash_1 = require("lodash");
var react_router_1 = require("react-router");
var is_node_1 = require("@reverbdotcom/commons/dist/is-node");
var csp_grid_data_manager_1 = require("../data_managers/csp_grid_data_manager");
var collection_header_store_1 = require("../components/discovery/stores/collection_header_store");
var curated_set_row_actions_1 = require("../components/discovery/actions/curated_set_row_actions");
function alreadyLoadedHeader(newParams) {
    var storeParams = collection_header_store_1.CollectionHeaderStore.getState().params;
    return storeParams && storeParams.curated_set_slug === newParams.curated_set_slug;
}
function curatedSetRowActions(excludedSlug) {
    curated_set_row_actions_1.default.fetch({
        sort: 'random',
        csp_type: true,
        excluded_slug: excludedSlug,
    });
}
var CollectionRoute = (React.createElement(react_router_1.Route, { key: "collection/:curated_set_slug", path: "collection/:curated_set_slug", props: { clientSide: true }, getComponent: function (location, cb) {
        require.ensure([], function (require) {
            cb(null, require('../components/discovery/csp/csp_curated_set_grid').default);
        }, 'csp');
    }, onChange: function (oldState, newState) {
        if (!lodash_1.isEqual(oldState.params, newState.params)) {
            collection_header_store_1.CollectionHeaderActions.fetchOrClear(newState.params);
        }
        curatedSetRowActions(newState.params.curated_set_slug);
        csp_grid_data_manager_1.default.fetchCSPs(newState, oldState);
    }, onEnter: function (newState) {
        if (is_node_1.default) {
            return;
        }
        curatedSetRowActions(newState.params.curated_set_slug);
        if (!alreadyLoadedHeader(newState.params)) {
            collection_header_store_1.CollectionHeaderActions.fetchOrClear(newState.params);
        }
        csp_grid_data_manager_1.default.fetchCSPs(newState);
    } }));
exports.default = CollectionRoute;
//# sourceMappingURL=collection.js.map


//////////////////
// WEBPACK FOOTER
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/discovery-ui/dist/routes/collection.js
// module id = Lj2A
// module chunks = 20 21